import type { $Enums } from '@prisma/client';
import { getStatusLabel } from '../../../status-labels';
import { definePolicy, type Policy } from '../kernel';
import { deny } from '../types';
import {
  decideHostCharge,
  HOST_CHARGE_FIELDS,
  HOST_CHARGE_OPS,
  type HostChargeFacts,
  type HostChargeField,
  type HostChargeOp,
} from './orderChargeBillLock';

/** Same charges window as the transfer page's `canEdit` (`DRAFT` or `SUBMITTED`, InventoryTransferLoadedPage.tsx) and as `INVENTORY_TRANSFER_EXPENSES_EDITABLE_STATUSES` — keep them equal until they are deduplicated. */
export const INVENTORY_TRANSFER_CHARGE_EDITABLE_STATUSES: readonly $Enums.InventoryTransferStatus[] = [
  'DRAFT',
  'SUBMITTED',
];

export type InventoryTransferExpenseFacts = HostChargeFacts<$Enums.InventoryTransferStatus>;

const statusLock = (status: InventoryTransferExpenseFacts['hostStatus']) =>
  deny(
    'INVENTORY_TRANSFER_EXPENSE_CHARGES_LOCKED',
    `Charges are locked once the inventory transfer is ${getStatusLabel(status)}.`
  );

/** Inventory transfer charges: the shared host charge rule over this host's window (`decideHostCharge`). */
export const inventoryTransferExpensePolicy: Policy<InventoryTransferExpenseFacts, HostChargeField, HostChargeOp> =
  definePolicy<InventoryTransferExpenseFacts, HostChargeField, HostChargeOp>({
    kind: 'inventory transfer charge',
    fields: HOST_CHARGE_FIELDS,
    ops: HOST_CHARGE_OPS,
    requires: {},
    entity: (facts, action) =>
      decideHostCharge(
        { editableStatuses: INVENTORY_TRANSFER_CHARGE_EDITABLE_STATUSES, statusLock: statusLock(facts.hostStatus) },
        facts,
        action
      ),
  });
